var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../../../I18N";


const MultiselectItemLabel = ({
  isSelected,
  isSuggested,
  label,
  property





}) => {
  const matchingStyles = 'bg-success-50 text-success-800';
  const nonMatchingStyles = 'bg-orange-50 text-orange-800';

  let styles = '';

  if (isSelected && isSuggested) {
    styles = matchingStyles;
  }

  if (!isSelected && isSuggested) {
    styles = nonMatchingStyles;
  }
  return (/*#__PURE__*/
    _jsx(Translate, { className: styles, context: property === null || property === void 0 ? void 0 : property.content }, void 0,
    label
    ));

};

export { MultiselectItemLabel };